import { Fragment } from "react";

const Loader = () => {
    return (
        <Fragment>
            <div className="pageLoader" data-testid="page-loader">
                <svg
                    className="circular"
                    viewBox="25 25 50 50"
                    aria-label="Content Loading"
                    focusable="false"
                >
                    <circle
                        className="path"
                        cx="50"
                        cy="50"
                        r="20"
                        fill="none"
                    />
                </svg>
            </div>
            <div className="loaderOverlay" data-testid="loader-overlay" />
        </Fragment>
    );
};

export default Loader;
